import React, { useEffect, useState } from "react";
import {
  Modal,
  Table,
  Form,
  TimePicker,
  Row,
  Col,
  InputNumber,
  Input,
  Tag,
  Tabs,
  Typography,
} from "antd";
import moment from "moment";
import {
  openNotificationWithIcon,
  getMinute,
  errorHandle,
} from "../../../../Function";
import { EditLichOTApi } from "../../../../../api/getOvertime";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
// import "antd-button-color/dist/css/style.css";
import {
  DeleteOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { lichSuChinhSuaApi } from "../../../../../api/getLichSuChamCong";

const { Text } = Typography;

const getClassColorOT = (type) => {
  let result;
  switch (type) {
    case "Done":
      result = "";
      break;
    case "Processing":
      result = "";
      break;
    case "Error":
      result = "timekeeper-error";
      break;
    default:
      result = "";
      break;
  }
  return result || "";
};

const ModalDetailItem = ({
  visible,
  onCancel,
  itemDetail,
  currentDate,
  updateData,
}) => {
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);
  const [form] = Form.useForm();
  const [dataLs, setDataLs] = useState([]);
  const [activeKey, setActiveKey] = useState("1");
  const [lsDuAn, setLsDuAn] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [timeStart, setTimeStart] = useState(null);
  const [timeEnd, setTimeEnd] = useState(null);
  const [timeStartCa2, setTimeStartCa2] = useState(null);
  const [timeEndCa2, setTimeEndCa2] = useState(null);
  const [timeStartHT, setTimeStartHT] = useState(
    itemDetail["time_system_" + currentDate]
      ? moment(
          moment(new Date()).format("YYYYMMDD") +
            itemDetail["time_system_" + currentDate].split("-")[0],
          "YYYYMMDDHH:mm"
        )
      : null
  );
  const [timeEndHT, setTimeEndHT] = useState(
    itemDetail["time_system_" + currentDate]
      ? moment(
          moment(new Date()).format("YYYYMMDD") +
            itemDetail["time_system_" + currentDate].split("-")[1],
          "YYYYMMDDHH:mm"
        )
      : null
  );

  const [lsTeamPer, setLsTeamPer] = useState([]);

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        nhanvien: itemDetail.nhanvien,
      });
      const timeRanges = itemDetail["time_regist_" + currentDate].includes("&&")
        ? String(itemDetail["time_regist_" + currentDate]).split("&&")
        : itemDetail["time_regist_" + currentDate];
      const valueVaoCa1 =
        timeRanges.length !== 2
          ? timeRanges.split("-")[0]
          : timeRanges[0]
          ? timeRanges[0].split("-")[0]
          : "";

      const valueRaCa1 =
        timeRanges.length !== 2
          ? timeRanges.split("-")[1]
          : timeRanges[0]
          ? timeRanges[0].split("-")[1]
          : "";
      const valueVaoCa2 =
        timeRanges.length === 2 ? timeRanges[1].split("-")[0] : null;
      const valueRaCa2 =
        timeRanges.length === 2 ? timeRanges[1].split("-")[1] : null;

      itemDetail.hasOwnProperty("col" + currentDate) &&
        form.setFieldsValue({
          ngay: moment(
            itemDetail["col" + currentDate].ngay,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY"),
          giovaodangky: valueVaoCa1,
          gioradangky: valueRaCa1,
          giovaodkca2: valueVaoCa2,
          gioradkca2: valueRaCa2,
          giovaothucte: itemDetail["time_actual_" + currentDate]
            ? itemDetail["time_actual_" + currentDate].split("-")[0]
            : "",
          giorathucte: itemDetail["time_actual_" + currentDate]
            ? itemDetail["time_actual_" + currentDate].split("-")[1]
            : "",
          giovaohethong: itemDetail["time_system_" + currentDate]
            ? itemDetail["time_system_" + currentDate].split("-")[0]
            : "",
          giorahethong: itemDetail["time_system_" + currentDate]
            ? itemDetail["time_system_" + currentDate].split("-")[1]
            : "",
          phutdangky: itemDetail["col" + currentDate].phutdangky,
          phutthucte: itemDetail["col" + currentDate].phutthucte,
          giailao: itemDetail["col" + currentDate].gioGiailao || "0",
          giogiailaoca1: itemDetail["col" + currentDate].gio_giai_lao_1 || "0",
        });
      itemDetail.hasOwnProperty("col" + currentDate) &&
        setLsDuAn(itemDetail["col" + currentDate].listDuan);

      const arrTeam = userInfo.team_permissions.map(
        (item, index) => item.phanquyen__ten_pq
      );

      setLsTeamPer([...new Set(arrTeam)]);
      setTimeStart(
        itemDetail["time_regist_" + currentDate]
          ? moment(
              moment(new Date()).format("YYYYMMDD") + valueVaoCa1,
              "YYYYMMDDHH:mm"
            )
          : null
      );
      setTimeEnd(
        itemDetail["time_regist_" + currentDate]
          ? moment(
              moment(new Date()).format("YYYYMMDD") + valueRaCa1,
              "YYYYMMDDHH:mm"
            )
          : null
      );
      setTimeStartCa2(
        valueVaoCa2 !== null
          ? moment(
              moment(new Date()).format("YYYYMMDD") + valueVaoCa2,
              "YYYYMMDDHH:mm"
            )
          : null
      );
      setTimeEndCa2(
        valueRaCa2 !== null
          ? moment(
              moment(new Date()).format("YYYYMMDD") + valueRaCa2,
              "YYYYMMDDHH:mm"
            )
          : null
      );
    }
  }, [visible]);

  const onEditing = () => {
    // @ts-ignore
    setTimeEnd(
      moment(
        moment(new Date()).format("YYYYMMDD") +
          itemDetail["time_regist_" + currentDate].split("-")[1],
        "YYYYMMDDHH:mm"
      )
    );
    // @ts-ignore
    setTimeStart(
      moment(
        moment(new Date()).format("YYYYMMDD") +
          itemDetail["time_regist_" + currentDate].split("-")[0],
        "YYYYMMDDHH:mm"
      )
    );
    // @ts-ignore
    setTimeEndHT(
      moment(
        moment(new Date()).format("YYYYMMDD") +
          itemDetail["time_system_" + currentDate].split("-")[1],
        "YYYYMMDDHH:mm"
      )
    );
    // @ts-ignore
    setTimeStartHT(
      moment(
        moment(new Date()).format("YYYYMMDD") +
          itemDetail["time_system_" + currentDate].split("-")[0],
        "YYYYMMDDHH:mm"
      )
    );
    const timeRanges = itemDetail["time_regist_" + currentDate].includes("&&")
      ? String(itemDetail["time_regist_" + currentDate]).split("&&")
      : itemDetail["time_regist_" + currentDate];

    const valueVaoCa1 =
      timeRanges.length !== 2
        ? timeRanges.split("-")[0]
        : timeRanges[0]
        ? timeRanges[0].split("-")[0]
        : "";

    const valueRaCa1 =
      timeRanges.length !== 2
        ? timeRanges.split("-")[1]
        : timeRanges[0]
        ? timeRanges[0].split("-")[1]
        : "";
    const valueVaoCa2 =
      timeRanges.length === 2 ? timeRanges[1].split("-")[0] : null;
    const valueRaCa2 =
      timeRanges.length === 2 ? timeRanges[1].split("-")[1] : null;

    form.setFieldsValue({
      giovaodangky: moment(
        moment(new Date()).format("YYYYMMDD") + valueVaoCa1,
        "YYYYMMDDHH:mm"
      ),
      gioradangky: moment(
        moment(new Date()).format("YYYYMMDD") + valueRaCa1,
        "YYYYMMDDHH:mm"
      ),
      giovaodkca2:
        valueVaoCa2 === null
          ? null
          : moment(
              moment(new Date()).format("YYYYMMDD") + valueVaoCa2,
              "YYYYMMDDHH:mm"
            ),
      gioradkca2:
        valueRaCa2 === null
          ? null
          : moment(
              moment(new Date()).format("YYYYMMDD") + valueRaCa2,
              "YYYYMMDDHH:mm"
            ),
      giovaohethong:
        itemDetail["time_system_" + currentDate].replaceAll(/\s-\s/gi, "") !==
        ""
          ? moment(
              moment(new Date()).format("YYYYMMDD") +
                itemDetail["time_system_" + currentDate].split("-")[0],
              "YYYYMMDDHH:mm"
            )
          : "",
      giorahethong:
        itemDetail["time_system_" + currentDate].replaceAll(/\s-\s/gi, "") !==
        ""
          ? moment(
              moment(new Date()).format("YYYYMMDD") +
                itemDetail["time_system_" + currentDate].split("-")[1],
              "YYYYMMDDHH:mm"
            )
          : "",
    });
    setIsEditing(true);
  };

  const onFinish = (values) => {
    EditLichOTApi({
      idOT: itemDetail["col" + currentDate].id,
      gio_vao_1: moment(form.getFieldValue("giovaodangky")).format("HH:mm"),
      gio_ra_1: moment(form.getFieldValue("gioradangky")).format("HH:mm"),
      gioVao:
        values.giovaodkca2 === null
          ? undefined
          : moment(form.getFieldValue("giovaodkca2")).format("HH:mm"),
      gioRa:
        values.gioradkca2 === null
          ? undefined
          : moment(form.getFieldValue("gioradkca2")).format("HH:mm"),
      gioVaoHT:
        form.getFieldValue("giovaohethong") !== ""
          ? moment(form.getFieldValue("giovaohethong")).format("HH:mm")
          : "",
      gioRaHT:
        form.getFieldValue("giorahethong") !== ""
          ? moment(form.getFieldValue("giorahethong")).format("HH:mm")
          : "",
      gioGiailao:
        values.giovaodkca2 === null && values.gioradkca2 === null
          ? undefined
          : form.getFieldValue("giailao").toString(),
      gio_giai_lao_1: form.getFieldValue("giogiailaoca1").toString(),
      ghiChu: form.getFieldValue("note"),
    })
      .then((r) => {
        updateData();
        onCancel();
        form.resetFields();
        setIsEditing(false);
        setActiveKey("1");
      })
      .catch((err) => {
        errorHandle(err);
      });
  };
  const onCancelModal = () => {
    updateData();
    form.resetFields();
    onCancel();
    setIsEditing(false);
    setActiveKey("1");
  };
  const tailLayout = {
    wrapperCol: { offset: 9, span: 15 },
  };

  const getDisableHourInEdit = () => {
    // @ts-ignore
    const timeIn = timeEnd ? timeEnd._d.getHours() : 24;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item > timeIn);
  };

  const getDisableHourOutEdit = () => {
    // @ts-ignore
    const timeIn = timeStart ? timeStart._d.getHours() : 0;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item < timeIn);
  };

  const getDisableHourInEditCa2 = () => {
    // @ts-ignore
    const timeIn = timeEndCa2 ? timeEndCa2._d.getHours() : 24;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item > timeIn);
  };

  const getDisableHourOutEditCa2 = () => {
    // @ts-ignore
    const timeIn = timeStartCa2 ? timeStartCa2._d.getHours() : 0;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item < timeIn);
  };

  const getDisableHourOutEditHT = () => {
    // @ts-ignore
    const timeCheck = form.getFieldValue("giovaohethong");
    const timeIn = timeCheck !== "" ? timeStartHT._d.getHours() : 0;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item < timeIn);
  };

  const getDisableHourInEditHT = () => {
    const timeCheck = form.getFieldValue("giorahethong");
    // @ts-ignore
    const timeIn = timeCheck !== "" ? timeEndHT._d.getHours() : 24;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item > timeIn);
  };

  const viewHistoryEdit = (values) => {
    // Id bảng chấm công cá nhân
    if (
      itemDetail["col" + currentDate].idCC == "" ||
      itemDetail["col" + currentDate].idCC == undefined
    ) {
      openNotificationWithIcon("error", "Lỗi", "Chưa có lịch sử chỉnh sửa");
      return false;
    }

    lichSuChinhSuaApi({ id: itemDetail["col" + currentDate].idCC }).then(
      (r) => {
        setDataLs(r.data);
        setActiveKey("2");
      }
    );
  };

  const FormViewHistoryEdit = ({ itemDetail }) => {
    const [loadingLs, setLoadingLs] = useState(false);
    const [pagerLs, setPagerLs] = useState({ pageSize: 10 });

    const columns = [
      {
        title: "STT",
        dataIndex: "index",
        key: "index",
        align: "center",
        fixed: "left",
        width: 50,
        render: (value, item, index) =>
          ((pagerLs.current || 1) - 1) * pagerLs.pageSize + index + 1,
      },
      {
        title: "Người điều chỉnh",
        dataIndex: "userEditName",
        key: "userEditName",
        type: "text",
        align: "center",
        fixed: "left",
        width: 120,
      },
      {
        title: "Thời gian cập nhật",
        dataIndex: "updated",
        key: "updated",
        type: "text",
        align: "center",
        width: 100,
        render: (text, record) =>
          moment(text, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm"),
      },
      {
        title: "Giờ vào đăng ký",
        dataIndex: "gioVaoOld",
        key: "gioVao",
        type: "text",
        align: "center",
        children: [
          {
            title: "Cũ",
            dataIndex: "gioVaoOld",
            key: "gioVaoOld",
            width: 70,
            // render:(text,record) => record.gioVaoOld[0]
          },
          {
            title: "Mới",
            dataIndex: "gioVaoNew",
            key: "gioVaoNew",
            width: 70,
            render: (text, record) =>
              text != "" ? (
                record.gioVaoNew != record.gioVaoOld ? (
                  <span style={{ color: "red" }}>{text}</span>
                ) : (
                  text
                )
              ) : (
                ""
              ),
          },
        ],
      },
      {
        title: "Giờ ra đăng ký",
        dataIndex: "gioRaOld",
        key: "gioRa",
        align: "center",
        children: [
          {
            title: "Cũ",
            dataIndex: "gioRaOld",
            key: "gioRaOld",
            width: 70,
            // render:(text,record)=> record.gioRaOld[0]
          },
          {
            title: "Mới",
            dataIndex: "gioRaNew",
            key: "gioRaNew",
            width: 70,
            render: (text, record) =>
              text != "" ? (
                record.gioRaNew != record.gioRaOld ? (
                  <span style={{ color: "red" }}>{text}</span>
                ) : (
                  text
                )
              ) : (
                ""
              ),
          },
        ],
      },
      {
        title: "Giờ vào hệ thống",
        dataIndex: "gioVaoOld_HT",
        key: "gioVaoOld_HT",
        type: "text",
        align: "center",
        children: [
          {
            title: "Cũ",
            dataIndex: "gioVaoOld_HT",
            key: "gioVaoOld_HT",
            width: 70,
            // render:(text,record) => record.gioVaoOld_HT[0]
          },
          {
            title: "Mới",
            dataIndex: "gioVaoNew_HT",
            key: "gioVaoNew_HT",
            width: 70,
            render: (text, record) =>
              text != "" ? (
                record.gioVaoNew_HT != record.gioVaoOld_HT ? (
                  <span style={{ color: "red" }}>{text}</span>
                ) : (
                  text
                )
              ) : (
                ""
              ),
          },
        ],
      },
      {
        title: "Giờ ra hệ thống",
        dataIndex: "gioRaOld_HT",
        key: "gioRaOld_HT",
        align: "center",
        children: [
          {
            title: "Cũ",
            dataIndex: "gioRaOld_HT",
            key: "gioRaOld_HT",
            width: 70,
            // render:(text,record)=> text
          },
          {
            title: "Mới",
            dataIndex: "gioRaNew_HT",
            key: "gioRaNew_HT",
            width: 70,
            render: (text, record) =>
              text != "" ? (
                record.gioRaNew_HT != record.gioRaOld_HT ? (
                  <span style={{ color: "red" }}>{text}</span>
                ) : (
                  text
                )
              ) : (
                ""
              ),
          },
        ],
      },
      {
        title: "Giải lao",
        dataIndex: "gioGiailao",
        key: "gioGiailao",
        align: "center",
        width: 70,
      },
      {
        title: "Ghi chú",
        dataIndex: "ghichu",
        key: "ghichu",
        align: "center",
      },
    ];

    return (
      <Table
        dataSource={itemDetail}
        columns={columns}
        loading={loadingLs}
        bordered={true}
        scroll={{ x: 1200 }}
        size={"small"}
        rowKey="id"
        // onChange={handleChange}
        pagination={false}
      />
    );
  };

  const handleClickDeleteEndCa1 = () => {
    if (timeEndCa2 === null) {
      setTimeStart(null);
      setTimeEnd(null);
    }
    form.setFieldsValue({ giovaodangky: timeStartCa2 });
    form.setFieldsValue({ gioradangky: timeEndCa2 });

    setTimeStartCa2(null);
    form.setFieldsValue({ giovaodkca2: null });

    setTimeEndCa2(null);
    form.setFieldsValue({ gioradkca2: null });
  };

  const handleClickDeleteEndCa2 = () => {
    setTimeStartCa2(null);
    form.setFieldsValue({ giovaodkca2: null });

    setTimeEndCa2(null);
    form.setFieldsValue({ gioradkca2: null });
  };

  const check_req =
    (timeStartCa2 === null && timeEndCa2 !== null) ||
    (timeStartCa2 !== null && timeEndCa2 === null) ||
    (timeStart === null && timeEnd !== null) ||
    (timeStart !== null && timeEnd === null) ||
    (timeStartCa2 === null &&
      timeEndCa2 === null &&
      timeStart === null &&
      timeEnd === null);

  const onSelectTimeEndCa1 = (value) => {
    setTimeEnd(value);
    // setTimeStartCa2(null);
    // form.setFieldsValue({ giovaodkca2: null });

    // setTimeEndCa2(null);
    // form.setFieldsValue({ gioradkca2: null });
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancelModal}
      title={"Chi tiết tăng ca"}
      style={{ minWidth: "800px" }}
      footer={false}
      className={
        itemDetail.hasOwnProperty("col" + currentDate)
          ? `${getClassColorOT(itemDetail["col" + currentDate].type)}-modal`
          : ""
      }
    >
      <Tabs activeKey={activeKey} type="card" tabBarStyle={{ display: "none" }}>
        <Tabs.TabPane tab={""} key="1">
          <Form
            form={form}
            name="control-hooks"
            onFinish={onFinish}
            layout={"vertical"}
          >
            <div className="body-model-edit-tang-ca">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="nhanvien" label="Nhân viên">
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="ngay"
                    label="Thời gian"
                    style={{ width: "100%" }}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} className="lich_dang_ky_ca">
                <Col span={24} style={{ paddingTop: 10, textAlign: "center" }}>
                  <h4 style={{ fontWeight: 700 }}>Ca 1</h4>
                </Col>
                <Col span={4} style={{ display: "flex" }}>
                  <Form.Item name="giovaodangky" label="Giờ vào đăng ký">
                    {isEditing ? (
                      <TimePicker
                        status={timeStart === null ? "error" : ""}
                        format="HH:mm"
                        placeholder={"Giờ vào"}
                        // inputReadOnly={true}
                        allowClear={false}
                        // @ts-ignore
                        value={timeStart}
                        // @ts-ignore
                        onSelect={(value) => {
                          setTimeStart(value);
                          form.setFieldsValue({ giovaodangky: value });
                        }}
                        disabledHours={getDisableHourInEdit}
                        style={{ borderRadius: 10, width: "100%" }}
                        showNow={false}
                      />
                    ) : (
                      <Input disabled />
                    )}
                  </Form.Item>
                </Col>
                <Col span={1} style={{ margin: "auto" }}>
                  {/* {isEditing && timeStart !== null && (
                    <Button
                      className="button-delete-ot"
                      onClick={handleClickDeleteStartCa1}
                    >
                      <DeleteOutlined className="icon-delete-ot" />
                    </Button>
                  )} */}
                </Col>
                <Col span={4} offset={1}>
                  <Form.Item name="gioradangky" label="Giờ ra đăng ký">
                    {isEditing ? (
                      <TimePicker
                        status={
                          timeStart !== null && timeEnd === null ? "error" : ""
                        }
                        format="HH:mm"
                        placeholder={"Giờ ra"}
                        // inputReadOnly={true}
                        // @ts-ignore
                        value={timeEnd}
                        allowClear={false}
                        // @ts-ignore
                        onSelect={(value) => {
                          onSelectTimeEndCa1(value);
                          form.setFieldsValue({ gioradangky: value });
                        }}
                        disabledHours={getDisableHourOutEdit}
                        style={{ borderRadius: 10, width: "100%" }}
                        showNow={false}
                        disabled={timeStart === null && true}
                      />
                    ) : (
                      <Input disabled />
                    )}
                  </Form.Item>
                </Col>
                <Col span={1} style={{ margin: "auto" }}>
                  {isEditing && timeEnd !== null && (
                    <Button
                      className="button-delete-ot"
                      onClick={handleClickDeleteEndCa1}
                    >
                      <DeleteOutlined className="icon-delete-ot" />
                    </Button>
                  )}
                </Col>
                <Col span={11} offset={2}>
                  <Form.Item name="giogiailaoca1" label="Giải lao">
                    <InputNumber
                      min={0}
                      disabled={!isEditing}
                      style={{ borderRadius: 10, width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {timeStart !== null && timeEnd !== null && (
                <Row gutter={16} className="lich_dang_ky_ca">
                  <Col
                    span={24}
                    style={{ paddingTop: 10, textAlign: "center" }}
                  >
                    <h4 style={{ fontWeight: 700 }}>Ca 2</h4>
                  </Col>
                  <Col span={4} style={{ display: "flex" }}>
                    <Form.Item name="giovaodkca2" label="Giờ vào đăng ký">
                      {isEditing ? (
                        <TimePicker
                          status={
                            timeStartCa2 === null && timeEndCa2 !== null
                              ? "error"
                              : ""
                          }
                          format="HH:mm"
                          placeholder={"Giờ vào"}
                          // inputReadOnly={true}
                          allowClear={false}
                          // @ts-ignore
                          value={timeStartCa2 || null}
                          // @ts-ignore
                          onSelect={(value) => {
                            setTimeStartCa2(value);
                            form.setFieldsValue({ giovaodkca2: value });
                          }}
                          disabledHours={getDisableHourInEditCa2}
                          style={{ borderRadius: 10, width: "100%" }}
                          showNow={false}
                        />
                      ) : (
                        <Input disabled />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={1} style={{ margin: "auto" }}>
                    {/* {isEditing && timeStartCa2 !== null && (
                      <Button
                        className="button-delete-ot"
                        onClick={handleClickDeleteStartCa2}
                      >
                        <DeleteOutlined className="icon-delete-ot" />
                      </Button>
                    )} */}
                  </Col>
                  <Col span={4} offset={1}>
                    <Form.Item name="gioradkca2" label="Giờ ra đăng ký">
                      {isEditing ? (
                        <TimePicker
                          status={
                            timeStartCa2 !== null && timeEndCa2 === null
                              ? "error"
                              : ""
                          }
                          format="HH:mm"
                          placeholder={"Giờ ra"}
                          // inputReadOnly={true}
                          // @ts-ignore
                          value={timeEndCa2}
                          allowClear={false}
                          // @ts-ignore
                          onSelect={(value) => {
                            setTimeEndCa2(value);
                            form.setFieldsValue({ gioradkca2: value });
                          }}
                          disabledHours={getDisableHourOutEditCa2}
                          style={{ borderRadius: 10, width: "100%" }}
                          showNow={false}
                          disabled={timeStartCa2 === null && true}
                        />
                      ) : (
                        <Input disabled />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={1} style={{ margin: "auto" }}>
                    {isEditing && timeEndCa2 !== null && (
                      <Button
                        className="button-delete-ot"
                        onClick={handleClickDeleteEndCa2}
                      >
                        <DeleteOutlined className="icon-delete-ot" />
                      </Button>
                    )}
                  </Col>
                  <Col span={11} offset={2}>
                    <Form.Item name="giailao" label="Giải lao">
                      <InputNumber
                        min={0}
                        disabled={!isEditing}
                        style={{ borderRadius: 10, width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              {isEditing ? (
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item name="giovaohethong" label="Giờ vào hệ thống">
                      <TimePicker
                        format="HH:mm"
                        placeholder={"-"}
                        inputReadOnly={true}
                        allowClear={false}
                        // @ts-ignore
                        value={timeStartHT}
                        // @ts-ignore
                        onSelect={(value) => {
                          setTimeStartHT(value);
                          form.setFieldsValue({ giovaohethong: value });
                        }}
                        disabledHours={getDisableHourInEditHT}
                        showNow={false}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="giorahethong" label="Giờ ra hệ thống">
                      <TimePicker
                        format="HH:mm"
                        placeholder={"-"}
                        inputReadOnly={true}
                        // @ts-ignore
                        value={timeEndHT}
                        allowClear={false}
                        // @ts-ignore
                        onSelect={(value) => {
                          setTimeEndHT(value);
                          form.setFieldsValue({ giorahethong: value });
                        }}
                        disabledHours={getDisableHourOutEditHT}
                        showNow={false}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              ) : null}
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="Dự án">
                    {lsDuAn &&
                      lsDuAn.map((item) => (
                        <Tag key={item.idDuan} style={{ fontSize: 14 }}>
                          {item.tenDuan}
                        </Tag>
                      ))}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="giovaothucte" label="Giờ vào thực tế">
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="giorathucte" label="Giờ ra thực tế">
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="phutdangky" label="Số phút đăng ký">
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="phutthucte" label="Số phút thực tế">
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <Row>
              <Col span={24}>
                {userInfo &&
                userInfo.team_permissions &&
                lsTeamPer.includes("overtime_create") &&
                isEditing ? (
                  <Row gutter={16}>
                    <Col span={24}>
                      <Form.Item
                        label="Ghi chú"
                        name="note"
                        rules={[{ required: true }]}
                        style={{ marginBottom: 6 }}
                      >
                        <Input maxLength={300} />
                      </Form.Item>
                    </Col>
                  </Row>
                ) : null}
              </Col>
            </Row>
            <Row gutter={16}>
              <Col>
                <span key="2" onClick={viewHistoryEdit} className="text-link">
                  <a className="text-link">
                    Xem lịch sử chỉnh sửa{" "}
                    <DoubleRightOutlined className="text-link" />
                  </a>
                </span>
              </Col>
            </Row>
            {userInfo &&
              userInfo.team_permissions &&
              lsTeamPer.includes("overtime_create") && (
                <Form.Item {...tailLayout}>
                  {isEditing ? (
                    // <Button onClick={onSave} style={{marginRight:10}}>Lưu</Button> :
                    <Button
                      onClick={() => {
                        form.submit();
                      }}
                      style={{ marginRight: 10 }}
                      disabled={check_req}
                    >
                      Lưu
                    </Button>
                  ) : (
                    <Button onClick={onEditing} style={{ marginRight: 10 }}>
                      Chỉnh sửa
                    </Button>
                  )}
                  <Button onClick={onCancelModal}>Thoát</Button>
                </Form.Item>
              )}
          </Form>
        </Tabs.TabPane>
        <Tabs.TabPane tab={""} key="2">
          <Row>
            <Col span={24} className={"mt-4 mb-4"}>
              <FormViewHistoryEdit itemDetail={dataLs}></FormViewHistoryEdit>
            </Col>
            <Col span={24} style={{ marginBottom: 6 }}>
              <Text
                italic
                onClick={() => setActiveKey("1")}
                style={{ cursor: "pointer" }}
              >
                <a className="text-link">
                  <DoubleLeftOutlined /> Xem chi tiết công{" "}
                </a>
              </Text>
            </Col>
          </Row>
          <Form.Item {...tailLayout}>
            <Button onClick={onCancelModal}>Thoát</Button>
          </Form.Item>
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  );
};

export default ModalDetailItem;
